// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-3yw0L";
var _3 = "backButton-1S0p3";
var _4 = "toolbar-tq2rq";
var _5 = "price-1Qdvh";
export { _1 as "__esModule", _2 as "button", _3 as "backButton", _4 as "toolbar", _5 as "price" }
export default { "__esModule": _1, "button": _2, "backButton": _3, "toolbar": _4, "price": _5 }
